import styled from 'styled-components'
import { Col, Input } from 'antd'
import { desktop } from '../../globalAssets/fontsize'
import { device } from '../../globalAssets/breakpoints'

export const WhiteCol = styled(Col)`
  display: none;
  @media ${device.laptop} {
    height: 87vh;
    position: sticky;
    top: 9vh;
    display: block;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 2px;
      background: ${(props) => props.theme.white};
    }
    &::-webkit-scrollbar-track {
      background: ${(props) => props.theme.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.primaryColor};
      height: 20vh;
    }
  }
`
export const TransparentCol = styled(Col)`
  background: none;
  padding-right: 0.55vw;
`
export const Colordiv = styled.div`
/* background: ${(props) => props.theme.foreground}; */
margin-left:.5vw;
/* overflow-y: visible; */
margin-bottom:1vw;
/* height: 90vh; */
&>h2{
    outline:none;
/* background: linear-gradient(rgba(16,171,222,0)-25%,rgba(0,116,255,0.7)150%); */
/* background: ${(props) => props.theme.foreground}; */
/* box-shadow:${(props) => props.theme.subtleShadow}; */
/* border-radius:10px; */
padding:2px 0;
margin:0;
width:fit-content;
font-weight:600;
color:${(props) => props.theme.color};
font-size:${desktop.normal};
border-bottom:${(props) => `1px solid ${props.theme.primaryColor}`}
}
`

export const TransaparentDiv = styled.div`
margin-right:.2vw;
/* background: ${(props) => props.theme.foreground}; */
background: none;
`
export const QuickLinksContainer = styled.div`
  border-bottom: ${(props) => `1px solid ${props.theme.tableLowLight}`};
  margin: 1vw 0;
  padding-bottom: 1vw;
`
export const SingleLink = styled.div`
  display: flex;
  margin-bottom: 0.5vw;
  align-items: center;
  transition: 0.2s ease-in;
  cursor: pointer;
  :hover {
    transform: scale(1.06);
    z-index: 10;
    box-shadow: none;
    padding: 0 0.4vw 0 0.3vw;
  }
`
export const SingleLinkSVG = styled.div`
 height: 4vw;
 min-width:5vw;
 cursor:pointer;
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 2.5vw;
 padding:0 0.5vw;
 border-radius:10px;
    /* width:50vw; */
    /* background:${(props) => props.color}; */
    background: ${(props) => props.theme.foreground};

    box-shadow:${(props) => props.theme.subtleShadow};
    transition: 0.2s ease-in;
 cursor:pointer;
     :hover{
         /* transform: scale(0.8); */
         box-shadow: none;
     }
`
export const SingleLinkText = styled.div`
  padding-left: 1vw;
  & > h1 {
    font-size: ${desktop.small};
    font-weight: 600;
    color: ${(props) => props.theme.color};
    margin: 0;
    cursor: pointer;
  }
  & > p {
    font-size: 0.75vw;
    color: ${(props) => props.theme.color};
    margin: 0;
    cursor: pointer;
  }
`

export const SingleTopic = styled.div`
  width: 95%;
  cursor: pointer;
  /* height:5vw; */
  margin-bottom: 0.5vw;
  /* height:100%; */
  border-radius: 5px;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  padding: 0.5vw;
  img {
    height: 2vw;
    width: 2vw;
    border-radius: 50%;
    margin-right: 0.5vw;
    object-fit: fill;
  }
  & > p {
    color: ${(props) => props.theme.color};
    font-size: 0.75vw;
    font-weight: 500;
  }
  & > div {
    display: flex;
    align-items: center;
    p {
      color: ${(props) => props.theme.color};
      font-size: 0.75vw;
      font-weight: 600;
      margin: 0;
    }
    h5 {
      color: ${(props) => props.theme.color};
      font-size: 0.75vw;
      font-weight: 400;

      margin: 0;
    }
  }
`
export const View = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  margin-top: 0.5vw;
  justify-content: center;
  div {
    color: ${(props) => props.theme.primaryColor};
    margin: 0;
    display: flex;
    align-items: center;
  }
  p {
    color: ${(props) => props.theme.primaryColor};
    margin: 0;
    margin-left: 0.5vw;
  }
`

export const ChatContainer = styled.div`
  width: 100%;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  padding-top: 1vw;
  margin-bottom: 1vw;
`
export const TypeMessageContainer = styled.div`
  display: flex;
  padding: 0 1vw;
  align-items: center;
  margin-bottom: 1vw;
  img {
    height: 2.5vw;
    width: 2.5vw;
    flex-shrink: 0;
    flex-grow: 0;
    margin-right: 0.5vw;
    border-radius: 50%;
  }
`
export const StyledInput = styled(Input.TextArea)`
  &&& {
    width: '100%';
    ${'' /* height: 15px; */}
    ${'' /* cursor: pointer; */}
    /* transition: ease-in all 0.3s; */
    padding-left: 10px;
    outline: none;
    font-size: 14px;
    overflow-y: auto;
    background: none;
    color: ${(props) => props.theme.color};

    .ant-input {
      background: ${(props) => props.theme.foreground};
      color: ${(props) => props.theme.color};
      font-size: ${desktop.normal};
    }
  }
`

export const SendContainer = styled.div`
/* border-top: ${(props) => `1px solid ${props.theme.subtleBlack}`}; */
`
export const ConfirmSend = styled.div`
  width: 100%;
  border-top: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  border-right: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  color: ${(props) => props.theme.color};
  font-size: ${desktop.normal};
  height: 5vh;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s ease-in;
  p {
    color: ${(props) => props.theme.secondaryColor};
    margin: 0 0.9vw 0 0;
    display: flex;
    font-size: 1.4vw;
    align-self: center;
  }
  :hover {
    font-size: ${desktop.small};
  }
`
export const Send = styled.div`
  background: ${(props) => props.theme.secondaryColor};
  color: ${(props) => props.theme.white};
  font-size: ${desktop.normal};
  height: 5vh;
  display: flex;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s ease-in;
  :hover {
    font-size: ${desktop.small};
  }
`
export const FeedsContainer = styled.div`
  width: 100%;
  padding: 1vw;
  background: ${(props) => props.theme.foreground};
  margin-bottom: 1vw;
  box-shadow: ${(props) => props.theme.subtleShadow};
`
export const AdsContainer = styled.div`
  & > div {
    display: flex;
    justify-content: space-between;
    & > h5 {
      padding: 0.2vw 0.4vw;
      background: ${(props) => props.theme.subtleGrey};
      border-radius: 2px;

      height: fit-content;
      margin: 0;
      color: ${(props) => props.theme.black};
    }
    & > div {
      display: block;
      & > h4 {
        color: ${(props) => props.theme.color};
        font-size: ${desktop.small};
        font-weight: 400;
        margin: 0;
        /* font-style: italic; */
      }
      & > h3 {
        color: ${(props) => props.theme.color};
        font-size: ${desktop.normal};
        font-weight: 500;
        margin: 0;
      }
    }
  }
  & > h3 {
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    font-weight: 400;
    margin: 0.3vw 0 0 0;
  }
`
export const FeedsContent = styled.div`
  cursor: pointer;
  & > div {
    display: flex;
    align-items: center;
    & > img {
      height: 2.5vw;
      width: 2.5vw;
      border-radius: 50%;
      margin-right: 1vw;
    }
    & > div {
      & > h3 {
        color: ${(props) => props.theme.color};
        font-size: ${desktop.normal};
        font-weight: 500;
        margin: 0;
      }
      & > h4 {
        color: ${(props) => props.theme.color};
        font-size: ${desktop.small};
        font-weight: 400;
        margin: 0;
        /* font-style: italic; */
      }
    }
  }
  & > h3 {
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    font-weight: 400;
    margin: 0.3vw 0 0 0;
  }
  & > img {
    height: 30vh;
    width: 100%;
    object-fit: cover;
  }
`

export const TopUsersContainer = styled.div`
  margin-top: 5px;
  width: 70%;
  padding: 10px;
  border-radius: 5px;
  box-shadow: ${(props) => props.theme.subtleShadow};
  background-color: ${(props) => props.theme.foreground};
  & > div {
    display: flex;
    margin-bottom: 15px;
    align-items: center;
    h5 {
      color: ${(props) => props.theme.primaryColor};
      font-size: 0.85vw;
      font-weight: 600;
      margin: 0 0 0 10px;
    }
    span {
      margin-left: auto;
      font-weight: 500;
      font-size: 0.75vw;
      color: ${(props) => props.theme.grey};
    }
    img {
      height: 30px;
      width: 30px;
      flex-grow: 0;
      flex-shrink: 0;
      border-radius: 100%;
      background-position: center;
    }
  }
  div:last-child {
    padding-top: 10px;
    margin-bottom: 0;
    border-top: ${(props) => `1px solid ${props.theme.subtleGrey}`};
  }
`

export const Searchbar = styled.div`
  margin: 15px 0 20px 0;
  cursor: pointer;
  width: 100%;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  border-radius: 5px;
  padding: 5px;
  align-items: center;
  display: flex;
  & > div {
    cursor: default;
    flex: 1;
    padding-left: 10px;
    display: flex;
    border-radius: 10px;
    background-color: ${(props) => props.theme.subtleGrey};
    height: 25px;
    align-items: center;
    p {
      color: ${(propa) => propa.theme.color};
      font-size: 15px;
      margin: 0;
      margin-left: 20px;
    }
  }
  @media ${device.laptop} {
    margin: 0 0 30px 0;
    padding: 1vw 3.6vw 1vw 1.5vw;
  }
`
